module.exports = __webpack_public_path__ + "static/media/story-10.9434b620.jpeg";